import { useMutation, useQueryClient } from '@tanstack/react-query';
import { couponService, type GoodsOption } from 'shared/src/api';
import { queryKey } from '../../../constant/queryKey';
import { useGoodsOptionsPricing } from './useGoodsOptionsPricing';
import { isNil } from 'shared/src/utils';
import { useGoodsSno } from '../../../hooks/useGoodsSno';

export const usePostBatchRedeemCoupon = (selected: GoodsOption[]) => {
  const client = useQueryClient();
  const sno = useGoodsSno();

  const { data: pricing } = useGoodsOptionsPricing({
    options: selected.map(option => ({
      sno: option.sno,
      count: option.purchase_count ?? 1,
    })),
  });

  return useMutation({
    mutationFn: async () => {
      if (isNil(pricing)) return null;

      return couponService.postBatchRedeemCoupons({
        coupon_snos: pricing.coupon_list.map(coupon => coupon.item.sno),
      });
    },
    throwOnError: false,
    onSuccess: () => {
      client.invalidateQueries({
        queryKey: queryKey.goodsOptionsPricing(sno, {
          options: selected.map(option => ({
            sno: option.sno,
            count: option.purchase_count ?? 1,
          })),
        }),
      });
    },
  });
};
